module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/5_59d1215b4f17521a1055c04054488531.png";